module.exports = __webpack_public_path__ + "assetpic.e2a5ded.png";